import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, concatMap, map } from 'rxjs/operators';

import {
  GetCurrentUserGroup,
  GetCurrentUserGroupSuccess,
  UpdateUserGroup,
  UpdateUserGroupSuccess,
  ECurrentUserGroupActions,
  CreateUserGroup,
  CreateUserGroupSuccess
} from '../actions/current-user-group.actions';
import { UserGroupsService } from '../../user-groups.service';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { GetUserGroups } from '../actions/user-groups-list.actions';
import { Store } from '@ngrx/store';
import { SetOriginalUserGroup, pendingChangesAction, ResetProperties } from 'app/core/store/actions/pending-changes.actions';
import { EPendingChangesSelectedAction } from 'app/core/models/pending-changes.enum';
import { IAppState } from 'app/IAppState';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Injectable()
export class CurrentUserGroupEffects {
  getUserGroupById$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetCurrentUserGroup>(ECurrentUserGroupActions.GetCurrentUserGroup),
      switchMap((param) => {
        return this._userGroupsService.getById(param.payload);
      }),
      switchMap((userGroup: IUserGroup) => {
        this._store.dispatch(new SetOriginalUserGroup(_.cloneDeep({
          ...userGroup, userOperations: {
            toAdd: {},
            toModify: {},
            toRemove: {}
          }
        })));
        return of(new GetCurrentUserGroupSuccess({ ...userGroup }))
      })
    )
  );
  updateUserGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType<UpdateUserGroup>(ECurrentUserGroupActions.UpdateUserGroup),
      switchMap((param) => {
        return this._userGroupsService.update(param.payload);
      }),
      switchMap((userGroup: IUserGroup) => {      
        this._store.dispatch(new GetUserGroups());
        this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE));
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');     
      return of(new UpdateUserGroupSuccess());
      })
    )
  );
  createUserGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType<CreateUserGroup>(ECurrentUserGroupActions.CreateUserGroup),
      switchMap((param) => {
        return this._userGroupsService.create(param.payload);
      }),
      switchMap((userGroup: IUserGroup) => {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
        this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE));
        this._store.dispatch(new SetOriginalUserGroup(_.cloneDeep(userGroup)));
        this._store.dispatch(new ResetProperties());
        return of(new CreateUserGroupSuccess(userGroup));
      })
    )
  );
  refreshCurrentUserGroup$ = createEffect(() =>
    this._actions$.pipe(
      ofType<CreateUserGroupSuccess>(ECurrentUserGroupActions.CreateUserGroupSuccess),
      switchMap(() => {
        return of(new GetUserGroups());
      })
    )
  );

  constructor(
    private _userGroupsService: UserGroupsService,
    private _actions$: Actions,
    private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _i18nService: I18nService,
    private _store: Store<IAppState>,
    private _showToastService: ShowToastService
  ) {
  }
}
